<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Revenue Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Revenue Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Revenue Report",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "cat",
          label: "Category",
          sortable: true,
        },
        {
          key: "amount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "source",
          label: "Source",
          sortable: true,
        },
        {
          key: "desc",
          label: "Description",
          sortable: true,
        },
        {
          key: "mode",
          label: "Payment Mode",
          sortable: true,
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
        },
        {
          key: "record",
          label: "Recorded On",
          sortable: true,
        },
        {
          key: "user",
          label: "Recorded By",
          sortable: true,
        },
      ],
      data: {
        category: 0,
        from: "",
        to: moment(new Date()).format("YYYY-MM-DD"),
      },
      assigned: [],
    };
  },
  computed: {
    ...mapGetters("revenues", ["Categories", "Report", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.assigned ? this.assigned.length : 1;
    },
  },
  watch: {
    Report(newValue) {
      if (newValue) {
        this.assign();
      }
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.assigned ? this.assigned.length : 1;
  },
  methods: {
    ...mapActions({
      FetchRevenues: "revenues/fetchReport",
      FetchCategories: "revenues/fetchRevCategories",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.assigned ? this.assigned.length : 1;
      this.currentPage = 1;
    },
    fetch_revenues() {
      this.FetchRevenues(this.data);
    },
    assign() {
      this.assigned = this.Report;
    },
  },
  created() {
    this.FetchCategories();
    this.FetchRevenues(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_revenue_acc')
        )
      "
    >
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <label>Category</label>
                <div class="input-group">
                  <select class="form-control" v-model="data.category">
                    <option value="0">All Categories</option>
                    <option
                      v-for="(t, index) in Categories"
                      :key="index"
                      :value="t.id"
                    >
                      {{ t.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label>From</label>
                <div class="input-group">
                  <input type="date" v-model="data.from" class="form-control" />
                </div>
              </div>
              <div class="col-md-3">
                <label>To</label>
                <div class="input-group">
                  <input type="date" v-model="data.to" class="form-control" />
                </div>
              </div>
              <div class="col-md-3 mt-2">
                <br />
                <button class="btn btn-success" @click="fetch_revenues()">
                  <i class="fa fa-search"></i> Search
                  <b-spinner
                    v-if="SaveStatus"
                    variant="light"
                    small
                    label="Spinning"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="assigned ? assigned.revenues : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <input
                    type="text"
                    class="form-control custom"
                    v-model="data.item.amount"
                    @input="addPreviousDebt($event.target.value, data.item.id)"
                  />
                </template>
              </b-table>
              <table
                width="100%"
                style="
                  border-top: 1px solid #ccc;
                  border-bottom: 1px solid #ccc;
                "
              >
                <tr>
                  <td width="50%"><h2>TOTAL</h2></td>
                  <td width="50%">
                    <h2>{{ assigned.tot }}/=</h2>
                  </td>
                </tr>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped>
.required {
  color: red !important;
}
/* .custom{
    width: 350px;
} */
</style>
